<template>
  <v-touch @panup="panUp">
    <div class="container">
      <p class="title">方法一</p>
      <p class="img"></p>
      <p class="text"><span class="icon">1</span>点击签到领取钻石</p>
      <p class="up_icon"></p>
    </div>
  </v-touch>
</template>

<script>
export default {
  created() {
    document.getElementsByTagName("title")[0].innerText = "月卡钻石领取教程";
  },
  methods: {
    panUp() {
      this.$router.push("/yueka_course_two");
    }
  }
};
</script>
<style lang="scss" scoped>
@import url("../../../assets/css/base.css");
.container {
  width: 100vw;
  height: 100vh;
  text-align: center;
  padding-left: 1.2rem;
  padding-right: 1.2rem;
  .title {
    font-size: 0.75rem;
    font-family: "PingFangSC-Semibold,PingFang SC";
    font-weight: 600;
    color: rgba(87, 86, 90, 1);
    margin-top: 1.7rem;
    margin-bottom: 0.6rem;
  }
  .img {
    display: inline-block;
    background: url("../../../assets/images/jiaocheng/yueka/ykzs_bg_01@2x.png")
      no-repeat;
    background-size: cover;
    width: 12.15rem;
    height: 19.9rem;
  }
  .text {
    margin-top: 0.85rem;
    font-size: 0.6rem;
    font-family: "PingFangSC-Semibold,PingFang SC";
    font-weight: 600;
    color: rgba(87, 86, 90, 1);
    .icon {
      display: inline-block;
      background: url("../../../assets/images/jiaocheng/weixin/num_bg@2x.png")
        no-repeat;
      background-size: cover;
      width: 1.2rem;
      height: 1.2rem;
      line-height: 1.2rem;
      font-size: 0.7rem;
      font-family: "PingFangSC-Semibold,PingFang SC";
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      margin-right: 0.5rem;
    }
  }
  .up_icon {
    display: inline-block;
    background: url("../../../assets/images/jiaocheng/weixin/up@2x.png")
      no-repeat;
    background-size: cover;
    width: 1.2rem;
    height: 1.2rem;
    margin-top: 0.95rem;
  }
  .btn {
    display: inline-block;
    width: 16.95rem;
    height: 2.4rem;
    line-height: 2.4rem;
    text-align: center;
    background: linear-gradient(
      90deg,
      rgba(48, 207, 238, 1) 0%,
      rgba(83, 255, 246, 1) 100%
    );
    border-radius: 1.2rem;
    margin-top: 0.9rem;
    font-size: 0.9rem;
    font-family: "PingFangSC-Semibold,PingFang SC";
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wsm_month_card/get/one.vue